import React, { useState, useEffect } from 'react';
import ImageApi from '../../../api/image';
import { Avatar } from 'antd';
import { Link } from "react-router-dom";

const AuntyItem = ({ id, firstName, lastName, imageId, imageData, religion, nationality, gender }) => {
  const [imageUrl, setImageUrl] = useState('');

   useEffect(() => {
      if (imageId) {
        ImageApi.getImage(imageData.thumbnailUrl).then((imageUrl) => {
          setImageUrl(imageUrl);
        });
      }
   }, []);

  return (
    <Link
      className="aunties-container-item text-decoration-none"
      to={`/ask-aunty-or-uncle/profile?id=${id}`}
    >
      <Avatar
        shape="circle"
        className="feed-item-header-image"
        src={imageUrl}
        icon="user"
        size={42}
      />
      <div className="aunties-container-item-content">
        <p className="aunties-container-item-title">{firstName} {lastName}</p>
        <div className="d-flex">
          <p className="aunties-container-item-description">{nationality}</p>
          {nationality ? <p className="aunties-container-item-description"> &nbsp; | &nbsp; </p> : null}
          <p className="aunties-container-item-description">{religion}</p>
          {religion && gender ? <p className="aunties-container-item-description"> &nbsp; | &nbsp;</p> : null}
          <p className="aunties-container-item-description">{gender}</p>
        </div>
      </div>
    </Link>
  );
};

export default AuntyItem;
